<template>
    <div>
        <tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionFrameStyle from "../DesignerQuestionFrameStyle.vue";

    export default {
        mixins: [
            DesignerQuestionFrameStyle
        ],
        props: {
            isFiredoor: {
                required: true,
            },
            title: {
                default(){
                    return 'Pick Your Frame Style';
                }
            },
            frameMaterial: {
                required: true,
            }
        },
        computed: {
            filtered_option_list(){
                if (this.option_list === null) {
                    return [];
                }

                return this.option_list.filter((key) => {
                    var panelLeft = '!==';
                    var panelRight = '!==';
                    var panelTop = '!==';
                    var material_check = '';

                    if (this.checkedPanels.indexOf("left") !== -1) {
                        panelLeft = '===';
                    }
                    if (this.checkedPanels.indexOf("right") !== -1) {
                        panelRight = '===';
                    }
                    if (this.checkedPanels.indexOf("top") !== -1) {
                        panelTop = '===';
                    }

                    if (this.frameMaterial !== 'n/a' && this.frameMaterial !== ''){
                        material_check = "key.material == " + this.frameMaterial + " && ";
                    }

                    return eval(material_check + "key.value !== null && key.left " + panelLeft + " true && key.right " + panelRight + " true && key.top " + panelTop + " true");
                });
            }
        }
    }
</script>
